<script >
	import PoweredBy from "./PoweredBy.svelte";

	let d = new Date(); 

	let currentYear = d.getFullYear();


</script>

<div class="myFooter">

	<div class="footerTopContainer">
		<div class="leftSideContainer">

			<div class="footerColumn">
				<div class="footerColumnItem">About Us</div>
				<div class="footerColumnItem">FAQ</div>
				<div class="footerColumnItem">Contact Us</div>
			</div>
			
		</div>

		<div class="righSideContainer">
			<PoweredBy/>	
		</div>	
	</div>

	<div class="footerBottomContainer">
		<div class="ArtisaneCopyRight">
			Copyright &copy; ArtiSaneFood {currentYear}
		</div>

	</div>	

	
	
</div>

<style >
	


@media only screen and (min-width: 768px) {

	.myFooter{
			width: 100vw;
			height: 50vh;
			background-color: black;
			scroll-snap-align: start;
			display: flex;
			flex-direction: column;

	}

	.footerTopContainer{
		width: 100%;
		height: 90%;
		display: flex;
		flex-direction: row;
	}

	.footerBottomContainer{
		width: 100%;
		height: 10%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		/*background-color: white;	*/
	}

	.ArtisaneCopyRight{

	}

	.leftSideContainer{
		width: 60%;
		height: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;

	}
	.footerColumn{
		width: 20%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		/*background-color: darkred;*/
		margin-top: 2%;
	}

	.footerColumnItem{
		width: 100%;
		height: 30%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		opacity: 0.8;
		cursor: pointer;
	}

	.footerColumnItem:hover{
		color: white;
		opacity: 1;
	}

	.righSideContainer{
		width: 40%;
		height: 100%;
	}
}


</style>
